module.exports = __webpack_public_path__ + "img/expand.651a0798.svg";